<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
          @submit.native.prevent="apply('ruleForm')"
        >
          <div class="lg:mb-2">
            <div ref="value">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{headerValue}}</label>
              <el-form-item prop="value">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.value"
                  :maxlength='maxLength'
                  :type="typeInput"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'

export default
{
  name: 'input-text-dialog',
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    typeInput: {
      type: String,
      default: 'text',
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: ''
      },
      rules: {
        value: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form.value)
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>
